export const KpoRejectionReason = {
  Mass: "Błędna masa",
  Vehicle: "Niewłaściwy pojazd",
  BadCompany: "Błędny podmiot",
  WasteCode: "Błędny kod odpadu",
}

export const KPO_REJECTION_REASON = {
  MASS: "Mass",
  VEHICLE: "Vehicle",
  BAD_COMPANY: "BadCompany",
  WASTE_CODE: "WasteCode",
}
